import * as React from 'react';

const AbortedIcon = ({
  className,
  dataTestId
}) => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 -960 960 960",
      className,
      "data-testid": dataTestId
    },
    /* @__PURE__ */ React.createElement("path", { d: "M140-440q-25 0-42.5-17.5T80-500q0-25 17.5-42.5T140-560h240q25 0 42.5 17.5T440-500q0 25-17.5 42.5T380-440H140Zm440 0q-25 0-42.5-17.5T520-500q0-25 17.5-42.5T580-560h240q25 0 42.5 17.5T880-500q0 25-17.5 42.5T820-440H580Z" })
  );
};

export { AbortedIcon };
//# sourceMappingURL=AbortedIcon.esm.js.map
